import { render, staticRenderFns } from "./academic_course_management.vue?vue&type=template&id=85ab1d86&scoped=true&"
import script from "./academic_course_management.vue?vue&type=script&lang=js&"
export * from "./academic_course_management.vue?vue&type=script&lang=js&"
import style0 from "./academic_course_management.vue?vue&type=style&index=0&id=85ab1d86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ab1d86",
  null
  
)

export default component.exports